import { useMountEffect } from 'primereact/hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import React, { useContext, useState } from 'react'
import { CommonContext } from '../../component/common/context/commonContext'
import { Button } from 'primereact/button'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const PiecePickingStatus = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const [pickingResult, setPickingResult] = useState<string | undefined>(undefined)
    let firstSound = true

    useMountEffect(() => {
        const pickingResult = location.state.pickingResult
        const outbId = location.state.outbId

        setPickingResult(pickingResult)

        if (pickingResult === 'NORMAL') {
            pickingComplete(outbId).then(() => {
                setTimeout(() => navigate(-1), 1000)
            })
        } else {
            const audio = document.getElementById('audio') as HTMLAudioElement

            if (audio) {
                audio.addEventListener(
                    'ended',
                    () => {
                        if (firstSound) {
                            firstSound = false
                            audio.play()
                        }
                    },
                    true,
                )
                audio.play()
            }
        }
    })

    const pickingComplete = async (outbId: number) => {
        const result = await $http().put('/outbound/piece-picking', {
            outbId,
        })

        if (result) {
            setPickingResult('SUCCESS')
        } else {
            setPickingResult('ERROR')
        }
    }
    return (
        <>
            {pickingResult === 'SUCCESS' && (
                <div className="flex h-full w-full bg-green-500 align-items-center justify-content-center font-bold text-8xl text-white">
                    {t(tokens.common.normal)}
                </div>
            )}
            {pickingResult === 'ERROR' && (
                <div className="flex h-full w-full bg-red-500 align-items-center justify-content-center font-bold text-8xl text-white">
                    {t(tokens.common.fail)}
                </div>
            )}
            {pickingResult === 'PARTIAL' && (
                <div className="h-full rdms-bg-warning justify-content-center font-bold p-4">
                    <div className="grid">
                        <div className="col-12 text-5xl text-left mt-4">
                            <span className="rdms-text-danger">{t(tokens.common.partial_cancellation)}</span> {t(tokens.common.is_item)}
                        </div>
                        <div className="col-12 text-left pt-0">
                            <span>{t(tokens.common.repack_and_rescan_item_qty)}</span>
                        </div>
                        <div className="col-12 font-bold text-xl mt-4 rdms-text-deepgrey">{t(tokens.common.product_name)}</div>
                        <div className="col-12 text-3xl">{location.state.goodsNm}</div>
                        <div className="col-12 font-bold text-xl mt-4 rdms-text-deepgrey">
                            {t(tokens.common.specification)}/{t(tokens.common.unit)}
                        </div>
                        <div className="col-12 text-3xl">
                            {location.state.specTxt} / {location.state.gdslsUnitCd}
                        </div>
                        <div className="col-12 grid mt-5">
                            <div className="col-5 rdms-text-deepgrey text-center">{t(tokens.inventory.existing_qty)}</div>
                            <div className="col-2"></div>
                            <div className="col-5 rdms-text-deepgrey text-center">{t(tokens.inventory.changed_qty)}</div>
                            <div className="col-5 text-6xl text-center">{location.state.goodsQty}</div>
                            <div className="col-2 align-items-center justify-content-center flex">
                                <i className="pi pi-arrow-right text-5xl font-bold" />
                            </div>
                            <div className="col-5 rdms-text-danger text-6xl text-center">{location.state.cancelQty}</div>
                        </div>
                        <div className="col-12 w-full">
                            <Button
                                label={t(tokens.common.accept)}
                                size="large"
                                className="w-full p-button-secondary mt-5"
                                onClick={async () => {
                                    await pickingComplete(location.state.outbId)
                                    navigate(-1)
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            {pickingResult === 'CANCEL' && (
                <div className="h-full bg-red-500 justify-content-center font-bold p-4">
                    <div className="col-12 grid mt-5 w-full">
                        <div className="col-12 rdms-text-deepgrey text-center">
                            <i className="pi pi-exclamation-triangle rdms-text-yellow text-8xl mt-4" />
                        </div>
                        <div className="col-12 text-white text-6xl text-center mt-7">{t(tokens.common.order_canceled)}</div>
                        <div className="col-12 text-white text-6xl text-center">{t(tokens.common.is_item)}</div>
                    </div>
                    <div className="col-12 w-full mt-5">
                        <Button
                            label={t(tokens.common.accept)}
                            size="large"
                            className="w-full p-button-secondary mt-5"
                            onClick={() => navigate(-1)}
                        />
                    </div>
                </div>
            )}
            {pickingResult === 'ALREADY' && (
                <div className="h-full justify-content-center font-bold p-4" style={{ backgroundColor: '#Ff5e1d' }}>
                    <div className="col-12 grid mt-5 w-full">
                        <div className="col-12 rdms-text-deepgrey text-center">
                            <i className="pi pi-exclamation-triangle rdms-text-yellow text-8xl mt-4" />
                        </div>
                        <div className="col-12 text-white text-6xl text-center mt-7">{t(tokens.common.already_scanned)}</div>
                        <div className="col-12 text-white text-6xl text-center ">{t(tokens.common.is_logistics_code)}</div>
                    </div>
                    <div className="col-12 w-full mt-5">
                        <Button
                            label={t(tokens.common.accept)}
                            size="large"
                            className="w-full p-button-secondary mt-5"
                            onClick={() => navigate(-1)}
                        />
                    </div>
                </div>
            )}
            {pickingResult === 'LAST' && (
                <div className="h-full bg-yellow-500 justify-content-center font-bold p-4">
                    <div className="col-12 grid mt-5 w-full">
                        <div className="col-12 rdms-text-deepgrey text-center">
                            <i className="pi pi-exclamation-triangle rdms-text-yellow text-8xl mt-4" />
                        </div>
                        <div className="col-12 text-white text-6xl text-center mt-7">{t(tokens.common.unsent_logistics_code)}</div>
                        <div className="col-12 text-white text-6xl text-center ">{t(tokens.common.please_contact_center_admin)}</div>
                    </div>
                    <div className="col-12 w-full mt-5">
                        <Button
                            label={t(tokens.common.accept)}
                            size="large"
                            className="w-full p-button-secondary mt-5"
                            onClick={() => navigate(-1)}
                        />
                    </div>
                </div>
            )}
            {!pickingResult && (
                <div className="h-full bg-yellow-500 justify-content-center font-bold p-4">
                    <div className="col-12 grid mt-5 w-full">
                        <div className="col-12 rdms-text-deepgrey text-center">
                            <i className="pi pi-exclamation-triangle rdms-text-yellow text-8xl mt-4" />
                        </div>
                        <div className="col-12 text-white text-6xl text-center mt-7">{t(tokens.common.logistics_number)}</div>
                        <div className="col-12 text-white text-6xl text-center ">{t(tokens.common.does_not_exist)}</div>
                    </div>
                    <div className="col-12 w-full mt-5">
                        <Button
                            label={t(tokens.common.accept)}
                            size="large"
                            className="w-full p-button-secondary mt-5"
                            onClick={() => navigate(-1)}
                        />
                    </div>
                </div>
            )}
            <audio id="audio" src="/warning.mp3" />
        </>
    )
}

export default PiecePickingStatus
